<div class="widget-image-detail">
    <div class="row">
        <div class="col-md-7 order-2 left" [ngClass]="(order == '2')?'order-md-1 pr-lg-5 pr-md-4':'order-md-2 pl-lg-5 pl-md-4'">
            <h4 class="mt-md-0 my-4">{{ dataWidgetDet?.title }} </h4>
            <div class="desc text-justify" [innerHTML]="dataWidgetDet?.content"></div>
            <a [href]="dataWidgetDet?.ext_link" 
                *ngIf="dataWidgetDet?.title_ext_link"
                class="mt-4 btn red-btn-icon">
                {{ dataWidgetDet?.title_ext_link }}
                <img class="ic-arr" src="../../../../assets/images/icon/arrow-left-white.svg" alt="">
            </a>
        </div>
        <div class="col-md-5 order-1 right" [ngClass]="(order == '2')?'order-md-2 pl-md-0':'order-md-1 pr-md-0'">
            <img [src]="apiAsset + dataWidgetDet?.picture" alt="" class="w-100">
        </div>
    </div>
</div>
